/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const customerWalletTransactionListDataSchema = z.object({
	data: z.array(
		z.object({
			id: z.number(),
			type: z.string(),
			amount: z.number(),
			runningBalance: z.number(),
			createdAt: z.iso.datetime(),
		}),
	),
})

export type CustomerWalletTransactionListDataSchema = z.infer<typeof customerWalletTransactionListDataSchema>
